import i18n from 'i18next';

export function parseErrorMessage(error) {
    return { message: i18n.t(error.error), name: error.error, ...error };
}
